import { createGlobalStyle } from 'styled-components';

// Styles globaux de l'univers Tartina
const GlobalStyles = createGlobalStyle`
  * { box-sizing: border-box; }

  html { scroll-behavior: smooth; }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.textPrimary};
    background-color: ${({ theme }) => theme.colors.background};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4 {
    font-family: ${({ theme }) => theme.fonts.heading};
    color: ${({ theme }) => theme.colors.chocolate};
    line-height: 1.1;
    margin: 0;
  }

  p { line-height: 1.7; }

  a { color: inherit; }

  img { max-width: 100%; display: block; }

  ::selection {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.chocolate};
  }

  /* Motif de vagues "seigaiha" — signature visuelle Tartina (bas des visuels) */
  .tartina-waves {
    background-color: ${({ theme }) => theme.colors.secondary};
    background-image: radial-gradient(circle at 10px 20px, transparent 9px, rgba(255,255,255,0.35) 9px, rgba(255,255,255,0.35) 11px, transparent 11px);
    background-size: 20px 20px;
  }

  /* Barre de défilement aux couleurs de la marque */
  ::-webkit-scrollbar { width: 12px; }
  ::-webkit-scrollbar-track { background: ${({ theme }) => theme.colors.cream}; }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.secondaryDark};
    border-radius: 999px;
    border: 3px solid ${({ theme }) => theme.colors.cream};
  }
`;

export default GlobalStyles;
